import {
  RepairPaymentEntry,
  RepairPaymentInfoCachedFinixTransferStatusEnum,
  RepairPaymentInfoViaEnum
} from '../../sdk'
import { checkIsEqualForTwoDecimal } from '../../utils/checkIsEqualForTwoDecimal/checkIsEqualForTwoDecimal'

export const isDueTotalZero = (dueTotal: number | undefined) => {
  if (dueTotal !== undefined && checkIsEqualForTwoDecimal(dueTotal, 0)) {
    return true
  }
  return false
}

export const getDueTotalFromPayments = (
  payments: RepairPaymentEntry[] | undefined,
  total: number | undefined
) => {
  if (!payments || total === undefined) {
    return
  }
  const dueTotal =
    total -
    payments.reduce(
      (prev, cur) =>
        cur.info!.via === RepairPaymentInfoViaEnum.Finix &&
        cur.info!.cachedFinixTransferStatus !==
          RepairPaymentInfoCachedFinixTransferStatusEnum.Succeeded
          ? prev
          : prev + cur.info!.amount! - (cur.info?.surcharge || 0),
      0
    )

  // prevents -0.00 from appearing if the computation results in -0.000000001 or similar
  if (isDueTotalZero(dueTotal)) {
    return 0
  }
  return dueTotal
}
